export default __webpack_public_path__ + "static/media/Image_gray.9a9ec55d.svg";